module.exports = __webpack_public_path__ + "static/media/mark.429978e5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/team/images/mark.jpeg
// module id = 1755
// module chunks = 146